import apiFetch from '../../apiFetch'

export default function (idVerraco, token) {
  return apiFetch({endPoint: `FichaVerraco/getHistoricoGrupoVerraco?idVerraco=` + idVerraco, method: 'GET', body: null, token: token})
}
